import React, { useState, useEffect } from "react";
import subtraction from "assets/icons/Subtraction.png";
import ContactPersonIcon from "assets/icons/ContactPersonIcon";
import TextField from "common/TextField";
import { useTranslation } from "react-i18next";
const Step2 = ({
  formik,
  handleBack,
  handleNext,
  handleError,
  handleCompletion,
}) => {
  const { t } = useTranslation();
  const STEP_ID = 2;

  const { firstName, lastName, email, userFirstName, userLastName, userEmail } =
    formik.values;

  let [disabled, setDisabled] = useState(() =>
    firstName?.length > 0 &&
    lastName?.length > 0 &&
    email?.length > 0 &&
    !formik.errors?.email &&
    userFirstName?.length > 0 &&
    userLastName?.length > 0 &&
    userEmail?.length > 0 &&
    !formik.errors?.userEmail
      ? false
      : true
  );

  useEffect(() => {
    setDisabled(
      firstName?.length > 0 &&
        lastName?.length > 0 &&
        email?.length > 0 &&
        !formik.errors?.email &&
        userFirstName?.length > 0 &&
        userLastName?.length > 0 &&
        userEmail?.length > 0 &&
        !formik.errors?.userEmail
        ? false
        : true
    );
  }, [
    firstName,
    lastName,
    email,
    formik.errors.email,
    userFirstName,
    userLastName,
    userEmail,
    formik.errors.userEmail,
  ]);

  useEffect(() => {
    if (!disabled) {
      handleError(STEP_ID, false);
      handleCompletion(STEP_ID, true);
    } else if (disabled) {
      handleError(STEP_ID, true);
      handleCompletion(STEP_ID, false);
    }
  }, [disabled]);
  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <h6 className="d-flex align-items-center">
        <ContactPersonIcon />
        <span className="mx-2">{t("contact-person")}</span>
      </h6>
      <p className="mt-2">{t("contact-person-description")}</p>
      <div className="inputField mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("first-name")}
          name="firstName"
          onChange={formik?.handleChange}
          value={formik?.values?.firstName}
          error={
            formik.errors.firstName && formik.touched.firstName
              ? formik.errors.firstName
              : ""
          }
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("last-name")}
          name="lastName"
          onChange={formik?.handleChange}
          value={formik?.values?.lastName}
          error={formik.touched.lastName && formik.errors.lastName}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("email-address")}
          name="email"
          onChange={formik?.handleChange}
          value={formik?.values?.email}
          error={formik.touched.email && formik.errors.email}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="tel"
          className="form-control"
          placeholder={t("phone-no")}
          name="phoneNumber"
          onChange={formik?.handleChange}
          value={formik?.values?.phoneNumber}
          error={formik.touched.phoneNumber && formik.errors.phoneNumber}
        />
      </div>

      <h6 className="mt-4 d-flex align-items-center">
        <img src={subtraction} />
        <span className="mx-2">{t("eg-admin-users")}</span>
      </h6>
      <p className="mt-2">{t("eg-admin-users-description")}</p>
      <div className="inputField mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("first-name")}
          name="userFirstName"
          onChange={formik?.handleChange}
          value={formik?.values?.userFirstName}
          error={formik.touched.userFirstName || ""}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("last-name")}
          name="userLastName"
          onChange={formik?.handleChange}
          value={formik?.values?.userLastName}
          error={formik.errors.userLastName || ""}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="email"
          className="form-control"
          placeholder="E.g. johndoe@branch.com"
          name="userEmail"
          onChange={formik?.handleChange}
          value={formik?.values?.userEmail}
          error={(formik.touched.userEmail && formik.errors.userEmail) || ""}
          isDisabled={true}
        />
      </div>

      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            marginRight: "15px",
            backgroundColor: "gray",
          }}
          onClick={handleBack}
        >
          {t("back")}
        </button>
        <button
          className="parentbtn"
          onClick={handleNext}
          style={{
            padding: "10px 35px",
            ...(disabled && { filter: "  opacity(30%)" }),
          }}
          disabled={disabled}
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
};

export default Step2;
